import React, { useState } from 'react';
import { Search, CheckCircle2, MessageSquare, FileText } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Pagination } from '../ui/Pagination';
interface OrdersTabProps {
  showToast: (msg: string) => void;
  setActiveTab: (tab: string) => void;
}
export function OrdersTab({
  showToast,
  setActiveTab
}: OrdersTabProps) {
  const [orderFilter, setOrderFilter] = useState('all');
  const [orderSearch, setOrderSearch] = useState('');
  const [orderPage, setOrderPage] = useState(1);
  const ORDERS_PER_PAGE = 5;
  const [orders, setOrders] = useState([{
    id: 1042,
    status: 'new',
    title: 'Натальная карта (Видео)',
    client: 'Мария В.',
    price: '5 000 ₽',
    time: '2 часа назад',
    deadline: ''
  }, {
    id: 1041,
    status: 'new',
    title: 'Синастрия (Видео)',
    client: 'Дмитрий Р.',
    price: '6 000 ₽',
    time: '5 часов назад',
    deadline: ''
  }, {
    id: 1038,
    status: 'progress',
    title: 'Соляр на год (Чат)',
    client: 'Анна К.',
    price: '4 000 ₽',
    time: '',
    deadline: 'Дедлайн: завтра'
  }, {
    id: 1037,
    status: 'progress',
    title: 'Натальная карта (Чат)',
    client: 'Ольга П.',
    price: '5 000 ₽',
    time: '',
    deadline: 'Дедлайн: 18 Окт'
  }, {
    id: 1035,
    status: 'progress',
    title: 'Детский гороскоп (Видео)',
    client: 'Иван С.',
    price: '4 500 ₽',
    time: '',
    deadline: 'Дедлайн: 20 Окт'
  }, {
    id: 1030,
    status: 'completed',
    title: 'Натальная карта (Видео)',
    client: 'Елена Т.',
    price: '5 000 ₽',
    time: '25 Сен',
    deadline: ''
  }, {
    id: 1028,
    status: 'completed',
    title: 'Соляр на год (Чат)',
    client: 'Павел М.',
    price: '4 000 ₽',
    time: '22 Сен',
    deadline: ''
  }, {
    id: 1025,
    status: 'completed',
    title: 'Синастрия (Видео)',
    client: 'Наталья С.',
    price: '6 000 ₽',
    time: '18 Сен',
    deadline: ''
  }]);
  const handleOrderAction = (orderId: number, action: 'accept' | 'reject' | 'complete') => {
    if (action === 'accept') {
      setOrders(prev => prev.map(o => o.id === orderId ? {
        ...o,
        status: 'progress',
        deadline: 'Дедлайн: через 3 дня'
      } : o));
      showToast('Заказ принят в работу ✓');
    } else if (action === 'reject') {
      setOrders(prev => prev.filter(o => o.id !== orderId));
      showToast('Заказ отклонён');
    } else if (action === 'complete') {
      setOrders(prev => prev.map(o => o.id === orderId ? {
        ...o,
        status: 'completed',
        time: 'Только что'
      } : o));
      showToast('Заказ завершён ✓');
    }
  };
  const filteredOrders = orders.filter(o => {
    const matchesFilter = orderFilter === 'all' || o.status === orderFilter;
    const matchesSearch = o.client.toLowerCase().includes(orderSearch.toLowerCase()) || o.id.toString().includes(orderSearch);
    return matchesFilter && matchesSearch;
  });
  const totalPages = Math.ceil(filteredOrders.length / ORDERS_PER_PAGE);
  const paginatedOrders = filteredOrders.slice((orderPage - 1) * ORDERS_PER_PAGE, orderPage * ORDERS_PER_PAGE);
  return <div className="space-y-6" data-id="element-12137">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-2" data-id="element-12138">
        <h2 className="text-xl sm:text-2xl font-bold text-slate-900" data-id="element-12139">
          Управление заказами{' '}
          <span className="text-slate-400 text-lg font-normal" data-id="element-12140">
            ({orders.length})
          </span>
        </h2>
        <div className="flex gap-2" data-id="element-12141">
          <Badge variant="warning" data-id="element-12142">
            {orders.filter(o => o.status === 'new').length} новых
          </Badge>
          <Badge variant="pro" data-id="element-12143">
            {orders.filter(o => o.status === 'progress').length} в работе
          </Badge>
        </div>
      </div>

      {/* Filters & Search */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 bg-white p-3 sm:p-4 rounded-2xl border border-slate-100 shadow-sm" data-id="element-12144">
        <div className="flex gap-1.5 overflow-x-auto w-full sm:w-auto pb-2 sm:pb-0 scrollbar-hide" data-id="element-12145">
          {[{
          id: 'all',
          label: 'Все',
          count: orders.length
        }, {
          id: 'new',
          label: 'Новые',
          count: orders.filter(o => o.status === 'new').length
        }, {
          id: 'progress',
          label: 'В работе',
          count: orders.filter(o => o.status === 'progress').length
        }, {
          id: 'completed',
          label: 'Завершённые',
          count: orders.filter(o => o.status === 'completed').length
        }].map(f => <button key={f.id} onClick={() => {
          setOrderFilter(f.id);
          setOrderPage(1);
        }} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium whitespace-nowrap transition-colors flex-shrink-0 ${orderFilter === f.id ? 'bg-indigo-50 text-indigo-700' : 'text-slate-600 hover:bg-slate-50'}`} data-id="element-12146">
              {f.label}
              <span className={`text-[10px] px-1.5 py-0.5 rounded-full ${orderFilter === f.id ? 'bg-indigo-100 text-indigo-700' : 'bg-slate-100 text-slate-500'}`} data-id="element-12147">
                {f.count}
              </span>
            </button>)}
        </div>
        <div className="w-full sm:w-64 relative" data-id="element-12148">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-12149">
            <Search className="h-4 w-4 text-slate-400" data-id="element-12150" />
          </div>
          <input type="text" placeholder="Поиск по № или имени..." value={orderSearch} onChange={e => {
          setOrderSearch(e.target.value);
          setOrderPage(1);
        }} className="block w-full pl-10 pr-3 py-2 border border-slate-200 rounded-xl leading-5 bg-white placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary sm:text-sm transition-colors" data-id="element-12151" />
        </div>
      </div>

      {filteredOrders.length === 0 ? <Card padding="lg" className="text-center py-16" data-id="element-12152">
          <CheckCircle2 className="w-12 h-12 text-emerald-400 mx-auto mb-4" data-id="element-12153" />
          <h3 className="font-bold text-slate-900 mb-2" data-id="element-12154">
            {orderSearch ? 'Ничего не найдено' : 'Все заказы обработаны!'}
          </h3>
          <p className="text-sm text-slate-500" data-id="element-12155">
            {orderSearch ? 'Попробуйте изменить запрос' : 'Новые заказы появятся здесь'}
          </p>
        </Card> : <div className="space-y-4" data-id="element-12156">
          {paginatedOrders.map(order => <Card key={order.id} padding="sm" className={`border-l-4 transition-all ${order.status === 'new' ? 'border-l-amber-500' : order.status === 'progress' ? 'border-l-indigo-500' : 'border-l-emerald-500 opacity-80 hover:opacity-100'}`} data-id="element-12157">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 px-3 py-2" data-id="element-12158">
                <div className="min-w-0" data-id="element-12159">
                  <div className="flex items-center gap-2 mb-1" data-id="element-12160">
                    <Badge variant={order.status === 'new' ? 'warning' : order.status === 'progress' ? 'pro' : 'success'} size="sm" data-id="element-12161">
                      {order.status === 'new' ? 'Новый заказ' : order.status === 'progress' ? 'В работе' : 'Завершён'}
                    </Badge>
                    <span className="text-[11px] text-slate-500 font-medium" data-id="element-12162">
                      #{order.id} •{' '}
                      {order.status === 'new' || order.status === 'completed' ? order.time : order.deadline}
                    </span>
                  </div>
                  <h3 className="font-bold text-slate-900 text-sm leading-tight" data-id="element-12163">
                    {order.title}
                  </h3>
                  <div className="text-xs text-slate-600 mt-0.5" data-id="element-12164">
                    Клиент:{' '}
                    <span className="font-medium text-slate-900" data-id="element-12165">
                      {order.client}
                    </span>{' '}
                    • {order.price}
                  </div>
                </div>
                <div className="flex gap-2 flex-shrink-0 mt-1 sm:mt-0" data-id="element-12166">
                  {order.status === 'new' ? <>
                      <Button variant="outline" size="sm" className="text-xs px-3 py-1.5 h-auto" onClick={() => handleOrderAction(order.id, 'reject')} data-id="element-12167">
                        Отклонить
                      </Button>
                      <Button variant="primary" size="sm" className="text-xs px-3 py-1.5 h-auto" onClick={() => handleOrderAction(order.id, 'accept')} data-id="element-12168">
                        Взять в работу
                      </Button>
                    </> : order.status === 'progress' ? <>
                      <Button variant="outline" size="sm" icon={<MessageSquare className="w-3.5 h-3.5" data-id="element-12170" />} className="text-xs px-3 py-1.5 h-auto" onClick={() => setActiveTab('chat')} data-id="element-12169">
                        Чат
                      </Button>
                      <Button variant="primary" size="sm" className="text-xs px-3 py-1.5 h-auto" onClick={() => handleOrderAction(order.id, 'complete')} data-id="element-12171">
                        Завершить
                      </Button>
                    </> : <Button variant="outline" size="sm" icon={<FileText className="w-3.5 h-3.5" data-id="element-12173" />} className="text-xs px-3 py-1.5 h-auto text-slate-600" onClick={() => showToast('Скачивание отчёта...')} data-id="element-12172">
                      Скачать отчёт
                    </Button>}
                </div>
              </div>
            </Card>)}

          {totalPages > 1 && <div className="pt-4 flex justify-center" data-id="element-12174">
              <Pagination currentPage={orderPage} totalPages={totalPages} onPageChange={setOrderPage} data-id="element-12175" />
            </div>}
        </div>}
    </div>;
}